import { StaffRepo } from "@/repos";
import { pageSize } from '@/configs/api.config'

const perPage = pageSize || 10;

class StaffService {
    async list(params) {
        params = params || {};
        params['page_size'] = params['page_size'] || perPage;

        let { data } = await StaffRepo.list(params);
        data.page = params.page || 1;
        data.totalPage = Math.ceil(data.count / params['page_size']);

        return data;
    }

    async get(id) {
        let { data } = await StaffRepo.get(id);
        return data;
    }

    async create(user) {
        let { data } = await StaffRepo.create(user);
        return data;
    }
    
    async update(id, user) {
        let { data } = await StaffRepo.update(id, user);
        return data;
    }

    async delete(id) {
        let { data } = await StaffRepo.delete(id);
        return data;
    }

    async setDepartments(id, departments) {
        let { data } = await StaffRepo.setDepartments(id, departments);
        return data;
    }

    async changePassword(id, newPassword) {
        let { data } = await StaffRepo.changePassword(id, newPassword);
        return data;
    }
}

export default new StaffService();